import { useMemo } from 'react';

import { useAtom } from 'jotai';

import { HexData } from 'pages/Settings/LocalMarketSettings/api/useLocalMarket/useLocalMarket';
import { activeDealerTypeAtom } from 'pages/Settings/LocalMarketSettings/DealerSidebar';
import {
  FranchiseCircleIconTooltip,
  IndependentCircleIconTooltip,
} from 'pages/Settings/LocalMarketSettings/icons/CircleIcon';
import Flex from '@lotlinx-aws/sparky-component-library/Sparky/Flex';
import Text from '@lotlinx-aws/sparky-component-library/Sparky/Text';

import styles from './MapPopup.module.scss';

export interface MapPopupProps {
  popupData: HexData;
}

/**
 * MapPopup
 */
export default function MapPopup({ popupData }: MapPopupProps) {
  const [activeDealerType] = useAtom(activeDealerTypeAtom);
  const isNewDealers = activeDealerType === 'new';

  return useMemo(
    () => (
      <div className={styles.mapPopup}>
        {popupData.hexStatus && (
          <Flex margin='0 0 16px 0'>
            <Text type='label-01' color='secondary'>
              {popupData.hexStatus}
            </Text>
          </Flex>
        )}
        <div className={styles.tooltipRow}>
          <Text type='label-emphasized-02'>In-market shoppers</Text>
          <Text type='body-compact-01'>{popupData.inMarketShoppers}</Text>
        </div>
        <div className={styles.tooltipRow}>
          <Text type='label-emphasized-02'>Dealerships</Text>
          <Text type='body-compact-01'>
            {isNewDealers ? popupData.dealerCountNew : popupData.dealerCountUsed}
          </Text>
        </div>
        <div className={styles.dealerList}>
          {popupData?.dealersInHex?.map((dealer) => {
            return activeDealerType === 'new' && dealer.dealerType === 'independent' ? (
              <div key={dealer.dealerId}> </div>
            ) : (
              <div key={dealer.dealerId} className={styles.dealerRow}>
                {dealer.dealerType === 'franchise' ? (
                  <FranchiseCircleIconTooltip />
                ) : (
                  <IndependentCircleIconTooltip />
                )}
                <Text type='body-compact-01' color='secondary'>
                  {dealer.dealerName}
                </Text>
              </div>
            );
          })}
        </div>
      </div>
    ),
    [popupData],
  );
}
